import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedDataService } from '@shared/services/shared-data.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormlyField } from '@ngx-formly/core';

import { BroadcastService, AppEvent, AppEventType } from '@app/shared/services/broadcast.service';
@Component({
  selector: 'db-output-dialog',
  templateUrl: './output-dialog.component.html',
  styleUrls: ['./output-dialog.component.scss']
})
export class OutputDialogComponent implements OnInit {
  public static readonly DIALOG_WIDTH = '900px';
  public OutputForm: FormGroup;
  public outputResponsibilitiesData: string[];
  public outputFormControlName: object = {};
  public model: any = {};
  public field: FormlyField;
  public jsonValue: object[];
  userPermission: any;
  checkIsLockDownEdit: any;
  editor: any;

  constructor(
    public dialogRef: MatDialogRef<OutputDialogComponent>,
    private form: FormBuilder,
    private sharedDataService: SharedDataService,
    private broadcastService: BroadcastService,

    @Inject(MAT_DIALOG_DATA) private OutputDialogData // currently this contains the multipleoutput data,
  ) {
  }

  public ngOnInit() {
    this.userPermission = this.sharedDataService.userIsAdmin;
    this.checkIsLockDownEdit = this.OutputDialogData[3].isLockDownEdit;
    this.field = this.OutputDialogData[3]; // field is the full original question
    this.model = this.OutputDialogData[2]; // model is the full answers for the questionaire
    this.jsonValue = this.OutputDialogData[2]; // json value is same as model, Redundant
    this.initializeDialog();
  }

  public initializeDialog(): void { // assigns data to the output in the html
    this.dialogRef.updateSize(OutputDialogComponent.DIALOG_WIDTH);
    this.outputResponsibilitiesData = this.OutputDialogData[0];

    this.outputFormControlName = Object.assign(
      {},
      ...this.getResponsibilitiesData(this.OutputDialogData[0])
    );
    this.OutputForm = this.form.group(this.assignFormNameControls());
  }

  public tinyMceSetting(): object {
    return {
      base_url: '/tinymce',
      branding: false,
      height: 200,
      skin: 'oxide',
      menubar: false,
      plugins: [
        'advlist lists link image directionality',
        'searchreplace visualblocks visualchars media table contextmenu paste textcolor colorpicker pagebreak code'
      ],
      paste_data_images: !0,
      toolbar: `
            copy undo redo formatselect |
            italic strikethrough forecolor backcolor |
            link |
            alignleft aligncenter alignright alignjustify |
            numlist bullist outdent indent |
            removeformat hr pagebreak code`,
      setup: (editor) => {
        this.editor = editor;

        if (this.checkIsLockDownEdit && !this.userPermission) {
          editor.settings.readonly = true;
        } 
        if (this.userPermission) {
          editor.settings.readonly = false;
        }
      },
      images_upload_handler: function (e: any, t: any, a: any) {
        t('data:' + e.blob().type + ';base64,' + e.base64());
      }
    };
  }

  public saveAndContinue(): void {
   this.model[this.field['key'] + '_MultipleOutputs'] = this.OutputForm.value;
   
   this.broadcastService.dispatch(new AppEvent(AppEventType.DataFetchingStarted));
   
   this.dialogRef.close(this.model);
  }
  private getResponsibilitiesData(param): [] {
    return param.map(element => {
      let name: any;

      name = this.model[this.field['key'] + '_MultipleOutputs']; // saving it to the model using the Original question ID + _MultipleOutputs so it can be identified up by backend.
      if (name == null) {
        name = {};
      }
      return { [element['id']]: [name[element['id']]] };
    });
  }

  private assignFormNameControls(): object {
    return this.outputFormControlName;
  }
}


